import { generateId } from '@freelancer/datastore/testing';
import { ProjectTitleEditRequestStatusApi } from 'api-typings/projects/projects';
import { ProjectTitleEditRequest } from './project-title-edit-request.model';

export interface GenerateProjectTitleEditRequestOptions {
  readonly projectId: number;
  readonly newTitle?: string;
  readonly requestedBy: number;
  readonly status?: ProjectTitleEditRequestStatusApi;
}

export function generateProjectTitleEditRequestObject({
  projectId,
  newTitle = 'Default New Project Title',
  requestedBy,
  status = ProjectTitleEditRequestStatusApi.PENDING,
}: GenerateProjectTitleEditRequestOptions): ProjectTitleEditRequest {
  const id = generateId();

  return { id, projectId, newTitle, requestedBy, status };
}
